import React, { useMemo } from 'react';
import { Icon, FdsIcon, ComponentSize } from '@tcc/fds';
import { useFormContext } from 'react-hook-form';
import { FieldData } from 'create/bulk/common/types';
import { convertForLocale, inferUnit } from 'util/unitConversion';
import { HybridCard } from './HybridCard';

const baseString = 'fields-list';

export function FieldsList() {
  const { watch } = useFormContext();
  const watchedFields: FieldData[] = watch('fields');

  const groupedFieldsData = useMemo(() => {
    const fieldsMap = watchedFields.reduce((map, field) => {
      if (!map.has(field.id)) {
        const area = convertForLocale({
          quantity: field?.area?.q || 0,
          unit: field?.area?.u || inferUnit('area').unitKey,
          unitType: 'area'
        });

        map.set(field.id, {
          // We get the field info for display the wrapper card
          fieldInfo: {
            id: field.id,
            area: area.scalarLocaleString + ' ' + area.unitKey,
            name: field.name,
            farmName: field.farm.name,
            clientName: field.farm.growerName,
            operationName: field.operationName,
          },
          // We store the individual fields to then get the hybrids and plan table from them.
          fields: [field]
        });
      } else {
        map.get(field.id)!.fields.push(field);
      }

      return map;
    }, new Map());

    return Array.from(fieldsMap.values());
  }, [watchedFields]);

  return (
    <div className={baseString}>
      {groupedFieldsData.map(({ fieldInfo, fields }, fieldIndex) => (
        <div key={fieldIndex} className={`${baseString}__field`}>
          <div className={`${baseString}__field-header`}>
            <div className="review-and-download__badge-icon">
              <Icon icon={FdsIcon.LocationOn} size={ComponentSize.Lg} />
            </div>
            <div>
              <h3 className={`${baseString}__field-name`}>{fieldInfo.name}</h3>
              <p className={`${baseString}__field-details`}>
                {fieldInfo.area} • {fieldInfo.clientName} • {fieldInfo.farmName} • {fieldInfo.operationName}
              </p>
            </div>
          </div>
          <div className={`${baseString}__hybrids-list`}>
            {fields.map((field: FieldData, fIndex: number) => (
              <HybridCard key={fIndex} field={field} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
